import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { Publisher } from '../model/publisher.class';
import { ActivatedRoute, Router } from '@angular/router';
import { ShaService} from '../services/sha.service';

@Component({
    selector: 'app-user-new',
    templateUrl: './user.new.component.html'
})
export class UserNewComponent {

    public constPublisher: Boolean = false;
    public publisher: Publisher;
    public publishers: Publisher[];
    public firstName: string;
    public lastName: string;
    public mail: string;
    public password: string;
    public passwordRepeat: string;
    public userType: string;
    public mailchecked = false;
    public shaService: ShaService;

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(
            (params) => {
                ;
                const id = params['id'];
                if (id !== '0') {
                    this.constPublisher = true;
                    userService.get(id, 'publisher').subscribe(data =>
                        this.publisher = data as Publisher
                    );
                } else {
                    // tslint:disable-next-line:max-line-length
                    userService.getPublishersWithout(userService.user.publisher.publisherId).subscribe(data => this.publishers = data as Publisher[]);
                }
            });
    }

    createUser() {
        this.message = '';
        if (this.password === this.passwordRepeat) {
            this.userService.checkMail(this.mail).subscribe(
                (data) => {
                    if (data as Boolean) {
                        this.mailchecked = true;
                    } else {
                        this.mailchecked = false;
                        if (this.userService.user.userType === this.userService.Admin && this.publisher
                            && this.userService.user.publisher.publisherId === this.publisher.publisherId) {
                            this.userType = this.userService.Admin;
                        }

                        if (this.userType === this.userService.userType[0]) {
                            this.publisher = this.userService.user.publisher;
                        }

                        this.shaService = new ShaService();
                        let hashedPassword = this.shaService.SHA256(this.password);
                        // tslint:disable-next-line:max-line-length
                        const user = new User(this.mail, this.lastName, this.firstName, hashedPassword, this.userType, null, this.publisher);
                        this.userService.create(user, 'user').subscribe(
                            () => {
                                this.router.navigate(['/publisher/detail', this.publisher.publisherId]);
                            },
                            (err) => {
                                this.message = 'Alle Pflichtfelder ausfüllen!';
                            });
                    }
                },
                (err) => {
                    this.message = 'Ungültige Mailadresse!';
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userNew/user.new.component.ts